// All or portions of this file Copyright © 2019 Amazon Web Services, Inc. or its affiliates or licensors.
// All rights reserved. For full license terms and conditions, please see the LICENSE file at the root of
// this distribution (the "License") or go to https://content.sumerian.amazonaws.com/engine/latest/license.txt.
// All use of the software is governed by the License. All materials are made available on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. Do not remove or modify any license notices.
import Joint from './Joint';

/**
 * Describes a collection of Joints. This class represents the hierarchy of a Skeleton and its original aspect (via the {@link Joint} class). This
 *        does not support posing the joints in any way... Use with a SkeletonPose to describe a skeleton in a specific pose.
 */
class Skeleton {
  /**
   * @param {string} name
   * @param {Array<Joint>} joints
   */
  constructor(name, joints) {
    this.id = '';
    this._name = name;
    this._joints = joints;
  }

  clone() {
    const name = this._name;
    const jointArray = this._joints;
    const joints = [];

    for (let j = 0, maxJ = jointArray.length; j < maxJ; j++) {
      const jointObj = jointArray[j];
      const jName = jointObj._name;
      const joint = new Joint(jName);

      joint._index = jointObj._index;
      joint._parentIndex = jointObj._parentIndex;
      joint._inverseBindPose.copy(jointObj._inverseBindPose);

      joints[j] = joint;
    }
    return new Skeleton(name, joints);
  }
}

export default Skeleton;
